export default __webpack_public_path__ + "static/media/default-user.1809f49d.png";